export default "__VITE_ASSET__CVjb8GXE__"